export const MEET_BIZY_PROMO_NAMESPACE = 'promo';
export const MEET_BIZY_PROMO_NAME = 'meet-bizy-v1';
